import "./HowToVote.module.css";
import Header from "@/reusable_sections/Header";
import StepByStepInstructions from "./sections/StepByStepInstructions";
import RemindersAndWarnings from "./sections/RemindersAndWarnings";
import InvitoAllAzione from "./sections/InvitoAllAzione";
import Footer from "@/reusable_sections/Footer";
export default function HowToVotePage() {
  return <div>
      <Header />
      <StepByStepInstructions />
      <RemindersAndWarnings />
      <InvitoAllAzione />
      <Footer />
    </div>;
}